import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20accessories%20flatlay%20on%20cream%20linen%20fabric%20with%20leather%20wallet%20watch%20and%20sunglasses%2C%20warm%20golden%20hour%20lighting%20through%20window%2C%20airy%20minimalist%20composition%2C%20editorial%20lifestyle%20photography%2C%20soft%20neutral%20beige%20and%20cognac%20tones%2C%20subtle%20shadows&width=1600&height=700&seq=cta-fashion-flatlay-2026&orientation=landscape"
          alt="Fashion accessories flatlay - Basetao Spreadsheet lifestyle"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-primary-800/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-white mb-4">
            Ready To Explore Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-white/75 mb-8 leading-relaxed">
            Access the latest Basetao spreadsheet with verified product links, accurate pricing and real QC photos. Start discovering amazing finds today.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-accent-500 text-white font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/25"
            >
              Visit Main Website
            </a>
            <Link
              to="/article/basetao-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/15 backdrop-blur-sm border border-white/25 text-white font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}